import { domAnimation, m } from 'framer-motion';

import FramerMotion from '~/components/FramerMotion';

type Props = {
  children: JSX.Element;
};

const AnimatedFrame = ({ children }: Props) => {
  return (
    <div className="absolute z-40 w-full">
      <FramerMotion feature={domAnimation}>
        <m.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          <div className="fixed w-full border-t border-grey-dark bg-black text-white">
            {children}
          </div>
        </m.div>
      </FramerMotion>
    </div>
  );
};

export default AnimatedFrame;
